import { render, staticRenderFns } from "./MarketPlaceAddEdit.vue?vue&type=template&id=c0de5e9c"
import script from "./MarketPlaceAddEdit.vue?vue&type=script&lang=js"
export * from "./MarketPlaceAddEdit.vue?vue&type=script&lang=js"
import style0 from "./MarketPlaceAddEdit.vue?vue&type=style&index=0&id=c0de5e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports